const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class TestimonialsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.15,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.15,
              spacing: 24,
            },
          },
          '(min-width: 1024px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('testimonials-carousel')) {
  customElements.define('testimonials-carousel', TestimonialsCarousel)
}
